import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BASE_URL from "../../../../config/config";
import "../../../../css/AddPost.css";

export default function EditCategory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    description: ""
  });
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [csrfToken, setCsrfToken] = useState("");

  useEffect(() => {
    // دریافت CSRF Token
    fetch(`${BASE_URL}/csrf-token`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setCsrfToken(data.csrfToken))
      .catch(console.error);

    // دریافت اطلاعات دسته‌بندی
    fetch(`${BASE_URL}/blog/categories/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setFormData({
          name: data.name,
          slug: data.slug,
          description: data.description || ""
        });
      })
      .catch((err) => {
        console.error("Error loading category:", err);
      });
  }, [id]);

  const generateSlug = (text) => {
    if (!text) return "";

    return text
      .replace(/[\s]+/g, "_")
      .replace(/[^\u0600-\u06FFa-zA-Z0-9_]/g, "")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleNameChange = (e) => {
    const name = e.target.value;
    setFormData((prev) => ({
      ...prev,
      name,
      slug: generateSlug(name),
    }));
  };

  const handleSlugChange = (e) => {
    const slug = generateSlug(e.target.value);
    setFormData((prev) => ({ ...prev, slug }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    // اعتبارسنجی فرم
    const newErrors = {};
    if (!formData.name) newErrors.name = "نام دسته‌بندی الزامی است";
    if (!formData.slug) newErrors.slug = "Slug الزامی است";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/blog/categories/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "CSRF-Token": csrfToken,
        },
        credentials: "include",
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        if (result.errors) setErrors(result.errors);
        setMessage(result.message || "خطا در ویرایش دسته‌بندی");
        return;
      }

      setMessage("دسته‌بندی با موفقیت ویرایش شد");
      setTimeout(() => navigate("/admin/blog/categories"), 1500);
    } catch (err) {
      setMessage("خطا در برقراری ارتباط با سرور");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="post-form-container">
      <h2>ویرایش دسته‌بندی</h2>

      {message && (
        <div
          className={`alert ${message.includes("موفق") ? "success" : "error"}`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>
              نام دسته‌بندی <span className="required">*</span>
            </label>
            <input
              name="name"
              value={formData.name}
              onChange={handleNameChange}
              className={errors.name ? "error" : ""}
            />
            {errors.name && <span className="error-text">{errors.name}</span>}
          </div>

          <div className="form-group">
            <label>
              Slug (لینک یکتا) <span className="required">*</span>
            </label>
            <input
              name="slug"
              value={formData.slug}
              onChange={handleSlugChange}
              className={errors.slug ? "error" : ""}
            />
            {errors.slug && <span className="error-text">{errors.slug}</span>}
          </div>
        </div>

        <div className="form-group">
          <label>توضیحات</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows="5"
          />
        </div>

        <div className="form-actions">
          <button type="submit" disabled={isLoading} className="btn-submit">
            {isLoading ? "در حال ذخیره..." : "ذخیره تغییرات"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/admin/blog/categories")}
            className="btn-cancel"
          >
            انصراف
          </button>
        </div>
      </form>
    </div>
  );
}